export default __webpack_public_path__ + "static/media/Bracers of Quilled Darts.1a9c38dd.jpg";